const getBottomBorderWidth = (state) => {
  if (state.menuIsOpen) return "0";
  if (state.isFocused) return "2px";
  return "1px";
};

const customStyles = {
  control: (base, state) => ({
    ...base,
    "&:hover": { borderColor: "none" },
    height: 30,
    boxShadow: "none",
    width: "100%",
    border: "1px solid hsl(0, 0%, 80%)",
    borderBottomWidth: getBottomBorderWidth(state),
    borderBottomLeftRadius: state.menuIsOpen ? "0" : "4px",
    borderBottomRightRadius: state.menuIsOpen ? "0" : "4px",
    transition: "0 all",
  }),
  singleValue: (base) => ({
    ...base,
    position: "static",
    transform: "none",
    maxWidth: "100%",
  }),
  placeholder: (base) => ({
    ...base,
    position: "static",
    transform: "none",
    maxWidth: "100%",
    fontStyle: "italic",
    color: "#a2a3a5",
  }),
  indicatorSeparator: (base) => ({ ...base, display: "none" }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    transform: state.selectProps.menuIsOpen && "rotate(180deg)",
    transition: ".2s transform",
    color: "#ff9951",
  }),
  option: (provided, state) => ({
    ...provided,
    borderTop: "none",
    borderBottom: "none",
    color: "#484848",
    display: state.isDisabled ? "none" : "block",
    "&:hover": {
      backgroundColor: "#eaf2f8",
      "&:last-child": {
        borderRadius: "4px",
      },
    },
    backgroundColor:
      (state.isSelected && "#eaf2f8") ||
      (state.isFocused && "#eaf2f8") ||
      provided.backgroundColor,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 50,
    marginTop: "0",
    borderTopLeftRadius: "0",
    borderTopRightRadius: "0",
    borderTop: "none",
    boxShadow: "none",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-38px",
      left: "0",
      right: "0",
      bottom: "0",
      borderRadius: "4px",
      zIndex: "-1",
      boxShadow:
        "0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%)",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      zIndex: "-1",
      borderTop: "1px solid hsl(0deg 0% 0% / 10%)",
    },
  }),
  menuList: (provided) => ({
    ...provided,
    paddingTop: "0",
    paddingBottom: "0",
  }),
};

export default customStyles;
